module.exports = __webpack_public_path__ + "img/adobe-illustrator.19dec442.png";